/* global getFinalEligibilityAmount addEventOnEligibilityButtonClick showIfEligibilityPrice*/

document.addEventListener('DOMContentLoaded', async function () {
	try {
		const removeEligibilityButtons = document.querySelectorAll('.remove-eligibility');
		await addEventOnEligibilityButtonClick(removeEligibilityButtons);

		const productMetaElement = document.getElementById('product-customer-data');

		if(!productMetaElement) {
			return;
		}

		const companyId = productMetaElement.getAttribute('data-customer-company');
		const eligibilityAmount = productMetaElement.getAttribute('data-customer-eligibility-amount');
		const finalEligibilityAmount = await getFinalEligibilityAmount(eligibilityAmount);

		if (finalEligibilityAmount <= 0) {
			return;
		}

		const addEligibilityButtons = document.querySelectorAll('.add-eligibility');

		showIfEligibilityPrice(addEligibilityButtons, finalEligibilityAmount, companyId);

		await addEventOnEligibilityButtonClick(addEligibilityButtons, companyId);
	} catch (error) {
		alert(error.message);
	}
});
